module.exports = __webpack_public_path__ + "static/img/Ollie_Wines_desktop.77d2fe9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ollie_Wines_desktop.jpg
// module id = DFAe
// module chunks = 0